import api from "./axios";

const withInstance = (instanceId, params = {}) =>
  instanceId ? { ...params, instanceId } : params;

export const getMintSpaceGateways = async (mintSpaceId, instanceId) => {
  const response = await api.get(`/mint-space/${mintSpaceId}/gateway`, {
    params: withInstance(instanceId),
  });
  return response.data;
};

export const createMintSpaceGateway = async (mintSpaceId, { label, url, instanceId }) => {
  const response = await api.post(`/mint-space/${mintSpaceId}/gateway`, {
    label,
    url,
    instanceId,
  });
  return response.data;
};

export const updateMintSpaceGateway = async (mintSpaceId, linkId, { label, url, instanceId }) => {
  const response = await api.put(`/mint-space/${mintSpaceId}/gateway/${linkId}`, {
    label,
    url,
    instanceId,
  });
  return response.data;
};

export const deleteMintSpaceGateway = async (mintSpaceId, linkId, instanceId) => {
  const response = await api.delete(`/mint-space/${mintSpaceId}/gateway/${linkId}`, {
    params: withInstance(instanceId),
  });
  return response.data;
};
